<template>
  <div style="padding-top:-100px;">
    <b-card-code style="background-color:rgba(255,255,255, 0.9);">
      <b-row>
        <b-col
          md="4"
          sm="4"
          lg="3"
          xs="12"
          class="d-flex align-items-center justify-content-start mb-1"
        >
          <label>Search</label>
          <b-input-group
            size="sm"
            style="padding-left:14px;"
          >
            <b-form-input
              id="filterInput"
              v-model="filter"
              type="search"
              placeholder="Type to Search"
              label-cols-sm="12"
              label-cols-md="2"
              label-cols-lg="2"
              style="background-color:rgba(255,255,255, 0.9);"
            />
            <b-input-group-append>
              <b-button
                :disabled="!filter"
                @click="filter = ''"
              >
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="12">
          <b-table
            :items="items"
            :fields="fields"
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #cell(devbuilding)="data">
              <feather-icon
                icon="HomeIcon"
                size="25"
                class="text-success align-middle"
                style="padding-right:5px"
              />
              <span class="font-weight-bolder align-middle"> {{ data.value }} </span>
              <feather-icon
                icon="ChevronRightIcon"
                size="30"
                class="text-success align-right"
                style="padding-right:5px"
              />
            </template>
            <template #cell(mainCircuitBreaker)="data">
              <div class="demo-inline-spacing">
                <b-badge
                  v-if="data.item.mainCircuitBreaker >= 1"
                  id="popover"
                  v-b-popover.hover.left.html="{variant: 'info', content:'<span style=color:green> <b>ON : ' + data.item.OnlineMCB + '</b></span><br><span style=color:#ff6c03> <b>Trip: ' + data.item.TripMCB + '</b></span><br><span style=color:red> <b>OFF : ' + data.item.OfflineMCB + '</b></span>'}"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="info"
                  title="MAIN CB"
                >
                  MAIN CB. (MDB)
                  {{ }}
                  <feather-icon
                    v-if="data.item.OfflineMCB >= 1 || data.item.TripMCB >= 1"
                    icon="BellIcon"
                    size="21"
                    class="text-info"
                    :badge="data.item.OfflineMCB + data.item.TripMCB"
                    badge-classes="badge-danger"
                  />
                </b-badge>
                {{ }}
                <b-badge
                  v-if="data.item.ATSControl >= 1"
                  v-b-popover.hover.left.html="{variant: 'primary', content:'<span style=color:green> <b>Main : ' + data.item.Main + '</b></span><br><span style=color:#ff6c03> <b>Gen : ' + data.item.Gen + '</b></span><br><span style=color:red> <b>AbNormal : ' + data.item.AbNormalATS + '</b></span>'}"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="primary"
                  title="AST CONTROL"
                >
                  AST CONTROL
                  {{ }}
                  <feather-icon
                    v-if="data.item.AbNormalATS >= 1 || data.item.Gen >= 1"
                    icon="BellIcon"
                    size="21"
                    class="text-primary"
                    :badge="data.item.AbNormalATS + data.item.Gen"
                    badge-classes="badge-danger"
                  />
                </b-badge>
                {{ }}
                <b-badge
                  v-if="data.item.generator >= 1"
                  id="popover"
                  v-b-popover.hover.left.html="{variant: 'success', content:'<span style=color:green> <b>Running : ' + data.item.Running + '</b></span><br><span style=color:#ff6c03> <b>OFF : ' + data.item.OFFGen + '</b></span><br><span style=color:red> <b>AbNormal : ' + data.item.AbNormalGen + '</b></span><br><span style=color:red> <b>Alarm : ' + data.item.AlarmGen + '</b></span>'}"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="success"
                  title="GENERATOR"
                >
                  GENERATOR
                  {{ }}
                  <feather-icon
                    v-if="data.item.OFFGen >= 1 || data.item.AbNormalGen >= 1 || data.item.AlarmGen >= 1"
                    icon="BellIcon"
                    size="21"
                    class="text-success"
                    :badge="data.item.OFFGen + data.item.AbNormalGen + data.item.AlarmGen"
                    badge-classes="badge-danger"
                  />
                </b-badge>
                {{ }}
                <b-badge
                  v-if="data.item.elevator >= 1"
                  id="popover"
                  v-b-popover.hover.left.html="{variant: 'warning', content:'<span style=color:green> <b>Normal : ' + data.item.NormalEle + '</b></span><br><span style=color:red> <b>Emergency Call : ' + data.item.EmergencyCall + '</b></span>'}"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="warning"
                  title="ELEVATOR"
                >
                  ELEVATOR
                  <span v-if="data.item.elevator > 2">1-{{ data.item.elevator }}</span>
                  <span v-if="data.item.elevator === 2">1, {{ data.item.elevator }}</span>
                  <span v-if="data.item.elevator === 1">{{ data.item.elevator }}</span>
                  {{ }}
                  <feather-icon
                    v-if="data.item.EmergencyCall >= 1"
                    icon="BellIcon"
                    size="21"
                    class="text-warning"
                    :badge="data.item.EmergencyCall"
                    badge-classes="badge-danger"
                  />
                </b-badge>
                {{ }}
                <b-badge
                  v-if="data.item.fireAlarm >= 1"
                  id="popover"
                  v-b-popover.hover.left.html="{variant: 'danger', content:'<span style=color:green> <b>Normal : ' + data.item.NormalFire + '</b></span><br><span style=color:red> <b>Alarm : ' + data.item.AlarmFire + '</b></span>'}"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="danger"
                  title="FIRE ALARM"
                >
                  FIRE ALARM
                  {{ }}
                  <feather-icon
                    v-if="data.item.AlarmFire >= 1"
                    icon="BellIcon"
                    size="21"
                    class="text-danger"
                    :badge="data.item.AlarmFire"
                    badge-classes="badge-danger"
                  />
                </b-badge>
                <b-badge
                  v-if="data.item.PowerMeter >= 1"
                  id="popover"
                  v-b-popover.hover.left.html="{variant: 'dark', content:'<span style=color:green> <b>ONLINE : ' + data.item.OnlinePWMeter + '</b></span><br><span style=color:red> <b>OFFLINE : ' + data.item.OfflinePWMeter + '</b></span>'}"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="dark"
                  title="Power Meter"
                >
                  POWER METER
                  {{ }}
                  <feather-icon
                    v-if="data.item.OfflinePWMeter >= 1"
                    icon="BellIcon"
                    size="21"
                    class="text-dark"
                    :badge="data.item.OfflinePWMeter"
                    badge-classes="badge-danger"
                  />
                </b-badge>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-card-code>
  </div>
</template>

<script>
import {
  BTable,
  BCol,
  BRow,
  BButton,
  BInputGroupAppend,
  BInputGroup,
  BFormInput,
  BBadge,
  VBPopover,
} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BTable,
    BCardCode,
    BCol,
    BRow,
    BButton,
    BInputGroupAppend,
    BInputGroup,
    BFormInput,
    BBadge,
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
  },
  data() {
    return {
      perPage: 100,
      pageOptions: [20, 50, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      fields: [
        {
          key: 'devbuilding', label: '', class: 'dev', thStyle: { background: 'rgba(255, 255, 255, 0.1)' },
        },
        {
          key: 'mainCircuitBreaker', label: '', class: 'system', thStyle: { background: 'rgba(255, 255, 255, 0.1)' },
        },
      ],
      items: [],
      status: [{
        1: 'Current', 2: 'Professional',
      },
      {
        1: 'light-success', 2: 'light-danger',
      }],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  mounted() {
    this.getBuilding()
    setInterval(() => {
      this.getBuilding()
    }, 7000)
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    getBuilding() {
      axios
        .get('/get-buildingNPT')
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
        })
    },
  },
}
</script>

<style scoped>
.table th{
  display: none;
}
.table th.dev div{
  font-weight: bold;
  font-size: 15px;
  margin-left: 30px;
}
#popover
{
    cursor: pointer;
}
.popover {
    background: rgb(233, 231, 231);
}
</style>
